export default __webpack_public_path__ + "static/media/mobile.fa144db8.png";